export default "__VITE_ASSET__DoIsYQOk__"